<template>
  <div class="logo-cropper-zoom-bar">
    <div class="logo-cropper-zoom-bar__wrapper">
      <div
        class="logo-cropper-zoom-bar__zoom-icon logo-cropper-zoom-bar__zoom-icon--left"
      >
        <button
          type="button"
          class="logo-cropper-zoom-bar__control-button"
          @click="zoomOut"
        >
          <IconMinus color="black" />
        </button>
      </div>
      <div
        class="logo-cropper-zoom-bar__line-wrapper"
        ref="line"
        @mousedown="onStart"
        @touchstart="onStart"
      >
        <div class="logo-cropper-zoom-bar__line">
          <div
            class="logo-cropper-zoom-bar__fill"
            :style="{
              flexGrow: calculatedZoom,
            }"
          />
          <div
            class="logo-cropper-zoom-bar__circle"
            :class="{ 'logo-cropper-zoom-bar__circle--focus': focus }"
            :style="{
              left: `${calculatedLeftPosition}%`,
            }"
          >
            <div
              class="logo-cropper-zoom-bar__inner-circle"
              :class="{ 'logo-cropper-zoom-bar__inner-circle--focus': focus }"
            />
          </div>
        </div>
      </div>

      <div
        class="logo-cropper-zoom-bar__zoom-icon logo-cropper-zoom-bar__zoom-icon--right"
      >
        <button
          type="button"
          class="logo-cropper-zoom-bar__control-button"
          @click="zoomIn"
        >
          <IconPlus
            color="black"
            class="logo-cropper-zoom-bar__control-button-icon"
          />
          <span class="logo-cropper-zoom-bar__control-button-text">Zoom</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import IconPlus from '~/components/icon/IconPlus.vue';
  import IconMinus from '~/components/icon/IconMinus.vue';

  export default {
    name: 'LogoCropperZoomBar',
    components: { IconPlus, IconMinus },
    props: {
      zoom: {
        type: Number,
        default: 0,
      },
    },
    data: () => ({
      focus: false,
    }),
    computed: {
      calculatedLeftPosition() {
        const calculatedLeftPosition = this.zoom * 100;
        return calculatedLeftPosition < 0 ? 0 : calculatedLeftPosition;
      },
      calculatedZoom() {
        return this.zoom < 0 ? 0 : this.zoom;
      },
    },
    mounted() {
      window.addEventListener('mouseup', this.onStop, { passive: false });
      window.addEventListener('mousemove', this.onDrag, { passive: false });
      window.addEventListener('touchmove', this.onDrag, { passive: false });
      window.addEventListener('touchend', this.onStop, { passive: false });
    },
    unmounted() {
      window.removeEventListener('mouseup', this.onStop);
      window.removeEventListener('mousemove', this.onDrag);
      window.removeEventListener('touchmove', this.onDrag);
      window.removeEventListener('touchend', this.onStop);
    },
    methods: {
      onDrag(event) {
        if (this.focus) {
          const position = event.touches
            ? event.touches[0].clientX
            : event.clientX;
          const line = this.$refs.line;

          if (line) {
            const { left, width } = line.getBoundingClientRect();
            this.$emit(
              'change',
              Math.min(1, Math.max(0, position - left) / width)
            );
          }
          if (event.preventDefault) {
            event.preventDefault();
          }
        }
      },
      onStop() {
        this.focus = false;
      },
      onStart(event) {
        this.focus = true;
        this.onDrag(event);
      },
      zoomIn() {
        this.$emit('change', Math.min(1, this.zoom + 0.1));
      },
      zoomOut() {
        this.$emit('change', Math.max(0, this.zoom - 0.1));
      },
    },
  };
</script>

<style lang="scss">
  .logo-cropper-zoom-bar {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    height: 50px;
    @include screen-md {
      width: 70%;
    }

    &__wrapper {
      display: flex;
      align-items: center;
      max-width: 400px;
      width: 100%;
    }

    &__line-wrapper {
      width: 100%;
      height: 20px;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      border-radius: 5px;
      cursor: pointer;
    }

    &__line {
      background: var(--itr-grey-mid);
      height: 5px;
      width: 100%;
      border-radius: 5px;
      display: flex;
      position: relative;
      align-items: center;
    }

    &__fill {
      background: var(--itr-green);
      align-self: stretch;
      flex-basis: auto;
      flex-direction: column;
      flex-shrink: 0;
    }

    &__circle {
      width: 30px;
      height: 30px;
      margin-left: -15px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      transition-duration: 0.2s;
      transition-property: background-color, box-shadow;
      background-color: transparent;
      &:hover {
        background-color: rgba(29, 161, 242, 0.1);
      }
      &--focus {
        background-color: rgba(29, 161, 242, 0.2);
      }
    }

    &__inner-circle {
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background-color: var(--itr-green);
      transform: scale(1);
      transition-duration: 0.1s;
      transition-property: transform;
      box-shadow:
        rgba(101, 119, 134, 0.2) 0px 0px 7px,
        rgba(101, 119, 134, 0.15) 0px 1px 3px 1px;
      &--focus {
        transform: scale(1.2);
      }
    }

    &__control-button {
      background-color: transparent;
      border: none;
      display: flex;
      align-items: center;
      cursor: pointer;
      margin: 0 10px;
    }
  }
</style>
